/**
 * Builds a list of options for a list box component.
 * It filters out any options that in the list of selected options
 * If a search text is given it will filter out the ones that match the search text
 * @param {ComboBoxOptions} selectedOptions - The options that are already selected.
 * @param {ComboBoxOptions} options - The available options.
 * @param {function} onSelect - The callback function to be called when an option is selected.
 * @param {string|undefined} searchText - The text to search for in the options' labels.
 * @returns {ListBoxOptions} - The filtered list of options for the list box.
 */
export const buildListBoxOptions = (selectedOptions, options, onSelect, searchText) => {
  const newListBoxOptions = (options || []).map(o => ({
    label: o.label,
    value: o.value,
    id: o.id,
    'data-testid': o['data-testid'],
    onSelect,
    groupHeader: o.groupHeader
  })).filter(o => !(selectedOptions || []).some(s => s.value === o.value || s.label === o.label)).filter(o => {
    if (!searchText || !o.label) {
      return true;
    }
    if (o.groupHeader) {
      return true;
    }
    return o.label.toLocaleUpperCase().includes(searchText.toLocaleUpperCase());
  });
  const groupPrunedListBoxOptions = (newListBoxOptions || []).map((o, index) => {
    if (!o.groupHeader) {
      return o;
    }
    // if the option after the group header is a group header or the end of the list then return undefined
    if (newListBoxOptions[index + 1]?.groupHeader || index === newListBoxOptions.length - 1) {
      return undefined;
    } else {
      return o;
    }
  }).filter(Boolean);
  return groupPrunedListBoxOptions;
};